import styled from 'styled-components';

export const Container = styled.div`
  // box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.5);
  border-radius: 20px;

  .img-wrapper {
    img {
      height: 211px;
      border-top-right-radius: 20px;
      border-top-left-radius: 20px;
    }
  }

  @media only screen and (max-width: 639px) {
    .img-wrapper {
      img {
        height: 201px;
      }
    }

    .program-title {
      font-size: 16px;
      font-weight: 600;
    }

    .program-description {
      font-size: 14px;
      font-weight: 300;
      line-height: 18px;
    }
  }

  .overlay {
    display: none;
  }

  &:hover {
    .overlay {
      display: flex;
      width: 100%;
      height: 211px;
      position: absolute;
      background: rgba(0, 0, 0, 0.7);
      border-radius: 20px;

      .unlock-btn {
        margin: auto;
        border: 1px solid #e8b12c;
        border-radius: 8px;
        padding: 11px 22px;
        font-weight: bold;
        color: #e8b12c;
      }
    }
  }

  svg {
    * {
      stroke: #e8b12c;
    }
  }
`;
